import { useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import Alert from '../../../components/Alert';
import InvoicingRow from '../../../components/InvoicingRow';
import { useNotificationStore } from '../../../components/notificationStore';

const InvoiceModal = ({ isOpen, requestId, onClose }) => {
	const { showSuccess, showError } = useNotificationStore();
	const modalRef = useRef();
	const invoiceQuery = useQuery({
		queryKey: ['invoice', requestId],
		queryFn: async () => {
			const { data } = await axios.get(`/requests/${requestId}/get-line-items`);
			return data;
		},
		enabled: false,
	});
	const lineItemMutation = useMutation({
		mutationFn: async (lineItem) => {
			const { data } = await axios.post(
				`/requests/${requestId}/fulfill-line-item/${lineItem.id}`,
				{ status: lineItem.status, actualCost: lineItem.actualCost },
			);
			return data;
		},
		onSuccess: () => {
			invoiceQuery.refetch();
			showSuccess('Line item fulfillment updated');
		},
		onError: (/*error*/) => {
			showError(
				'There was a problem updating line item fulfillment. Please try again.',
			);
		},
	});
	useEffect(() => {
		if (isOpen) {
			modalRef.current.showModal();
			invoiceQuery.refetch();
		}
	}, [isOpen]);

	return (
		<dialog id="invoice-dialog" className="modal modal-top" ref={modalRef}>
			<div className="modal-box">
				<h3>Service Request Line Items</h3>
				<div className="py-4">
					{invoiceQuery.isLoading && <p>Loading...</p>}
					{invoiceQuery.isError && (
						<Alert message="There was a problem loading line items!" />
					)}
					{invoiceQuery.isSuccess && (
						<table className="table w-full">
							<thead>
								<tr>
									<th></th>
									<th>SKU</th>
									<th>Scheduled Date</th>
									<th>Service Unit Max</th>
									<th>Actual Cost</th>
									<th>Fulfilled Date</th>
									<th>Fulfillment Status</th>
									<th>Fulfill?</th>
								</tr>
							</thead>
							<tbody>
								{invoiceQuery.data.ilos_claims.map((item, index) => (
									<InvoicingRow
										key={item.id}
										variant="modal"
										item={item}
										index={index}
										total={invoiceQuery.data.ilos_claims.length}
										lineItemMutation={lineItemMutation}
									/>
								))}
							</tbody>
						</table>
					)}
				</div>
				<div className="modal-action">
					<form method="dialog">
						<button className="btn btn-primary" onClick={onClose}>
							Close
						</button>
					</form>
				</div>
			</div>
		</dialog>
	);
};

InvoiceModal.propTypes = {
	isOpen: PropTypes.bool,
	requestId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func.isRequired,
};

export default InvoiceModal;
